const FALLBACK = '/';
const MAX_LENGTH = 2048;
/** Origem fictícia: só serve para o analisador de URL normalizar o caminho (não vai ao resultado). */
const PROBE_ORIGIN = 'http://destino.invalid';

function hasControlChars(value: string): boolean {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code <= 0x1f || code === 0x7f) return true;
  }
  return false;
}

/**
 * Caminho interno = começa com UMA barra. "//host" e "/\host" são lidos pelo navegador como
 * outro site (o "\" vira "/"), e tabs/quebras de linha são removidos do endereço antes da
 * análise ("/\t/host" vira "//host"), por isso também caem fora.
 */
function isInternalPath(path: string): boolean {
  return (
    path.startsWith('/') && !path.startsWith('//') && !path.includes('\\') && !hasControlChars(path)
  );
}

/** A rota de entrada nunca é destino (daria um laço); o roteador ignora caixa e barra final. */
function isLoginPath(pathname: string): boolean {
  let decoded = pathname;
  try {
    decoded = decodeURIComponent(pathname);
  } catch {
    /* sequência % inválida: vale o texto como está */
  }
  const normalized = decoded.toLowerCase().replace(/\/+$/, '');
  return normalized === '/login' || normalized.startsWith('/login/');
}

/** Junta pathname/search/hash de um objeto de localização; null se estiver malformado. */
function pathFromLocation(value: object): string | null {
  const { pathname, search = '', hash = '' } = value as Record<string, unknown>;
  if (typeof pathname !== 'string' || typeof search !== 'string' || typeof hash !== 'string') {
    return null;
  }
  if (search !== '' && !search.startsWith('?')) return null;
  if (hash !== '' && !hash.startsWith('#')) return null;
  return pathname + search + hash;
}

/**
 * Destino seguro para depois do login. Aceita uma localização do roteador (`pathname`, `search`,
 * `hash`) ou uma string de caminho interno; em qualquer dúvida devolve "/". O valor vem do
 * `state` do histórico e pode ter sido forjado, então nunca é usado sem passar por aqui
 * (evita redirecionamento aberto para outro site).
 */
export function safeRedirectTarget(from: unknown): string {
  try {
    let raw: string | null = null;
    if (typeof from === 'string') raw = from;
    else if (typeof from === 'object' && from !== null) raw = pathFromLocation(from);

    if (raw === null || raw.length > MAX_LENGTH || !isInternalPath(raw)) return FALLBACK;

    // Normaliza ("/a/../b" → "/b") e confere de novo: "/.//host" só vira "//host" depois disto.
    const url = new URL(raw, PROBE_ORIGIN);
    if (url.origin !== PROBE_ORIGIN) return FALLBACK;
    const normalized = url.pathname + url.search + url.hash;
    if (!isInternalPath(normalized) || isLoginPath(url.pathname)) return FALLBACK;
    return normalized;
  } catch {
    return FALLBACK;
  }
}
